import {
  HttpHandler,
  HttpHeaderResponse,
  HttpInterceptor,
  HttpProgressEvent,
  HttpRequest,
  HttpResponse,
  HttpSentEvent,
  HttpUserEvent,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { mergeMap, take } from 'rxjs/operators';
import { Language, defaultLanguage, settings$ } from 'src/app/core/contracts';
import { environment } from 'src/environments/environment';

@Injectable()
export class HeaderInterceptor implements HttpInterceptor {
  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpSentEvent | HttpHeaderResponse | HttpProgressEvent | HttpResponse<unknown> | HttpUserEvent<unknown>> {
    return settings$.pipe(
      take(1),
      mergeMap(settings => {
        const headers = { 'accept-language': settings ? Language[settings.language] : Language[defaultLanguage] };
        if (req.url !== environment.url + '/api/version/status') {
          // shouldn't add version header on version endpoint so that the request won't get rejected once support for the version is dropped
          // this will allow the api to respond with force update status
          // the api will use the default version on requests without the version header
          headers['version'] = environment.version;
        }
        const request = req.clone({
          setHeaders: headers,
        });
        // may set other headers as needed
        return next.handle(request);
      })
    );
  }
}
